import * as tslib_1 from "tslib";
import { Router } from '@angular/router';
import { Actions, Effect } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { toPayload } from '../../core/helpers/rx-pipes';
import { AuthService } from '../services/auth.service';
import * as auth from '../actions/auth.actions';
import * as user from '../actions/user';
import * as preferences from '../../base/actions/preferences.actions';
import * as fromAuth from '../reducers';
import { CATALOG_ONLY, ThemeConfig } from '../../core/helpers/theme-config';
var routeName = ThemeConfig.viewMode === CATALOG_ONLY
    ? '/' + ThemeConfig.get('catalog', 'route-name')
    : '/';
var AuthEffects = /** @class */ (function () {
    function AuthEffects(actions$, authService, router, store) {
        var _this = this;
        this.actions$ = actions$;
        this.authService = authService;
        this.router = router;
        this.store = store;
        this.login$ = this.actions$.ofType(auth.LOGIN)
            .pipe(toPayload(), switchMap(function (authDetails) {
            return _this.authService.login(authDetails)
                .pipe(map(function (res) { return new auth.LoginSuccess(res); }), catchError(function (error) { return of(new auth.LoginFailure(error)); }));
        }));
        this.loginSuccess = this.actions$.ofType(auth.LOGIN_SUCCESS)
            .pipe(switchMap(function (action) { return of(new user.Get(), new preferences.GetTenantPreferences()); }));
        this.getLoginDone$ = this.actions$.ofType(user.GET_SUCCESS, user.GET_FAILED)
            .pipe(withLatestFrom(this.store.pipe(select(fromAuth.getReturnUrl)), function (action, returnUrl) { return returnUrl; }), tap(function (returnUrl) { return _this.router.navigateByUrl(returnUrl || routeName); }));
        this.loginRedirect$ = this.actions$.ofType(auth.LOGIN_REDIRECT)
            .pipe(tap(function () { return _this.router.navigate(['/login']); }));
        this.logoutRedirect$ = this.actions$.ofType(auth.LOGOUT)
            .pipe(map(function () { return new auth.LoginRedirect('/'); }));
    }
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], AuthEffects.prototype, "login$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], AuthEffects.prototype, "loginSuccess", void 0);
    tslib_1.__decorate([
        Effect({ dispatch: false }),
        tslib_1.__metadata("design:type", Observable)
    ], AuthEffects.prototype, "getLoginDone$", void 0);
    tslib_1.__decorate([
        Effect({ dispatch: false }),
        tslib_1.__metadata("design:type", Observable)
    ], AuthEffects.prototype, "loginRedirect$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], AuthEffects.prototype, "logoutRedirect$", void 0);
    return AuthEffects;
}());
export { AuthEffects };
